var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('u-dialog', {
    attrs: {
      "title": "Terms of Use",
      "persistent": "",
      "width": "600"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on,
          isValid: _vm.isValid
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_vm.isLoaded ? _c('div', [_vm._l(_vm.termsList, function (term) {
    return [_c('page-section', {
      key: term._id,
      staticClass: "page-section--xxs pb-0 pt-0",
      scopedSlots: _vm._u([{
        key: "pageSectionImmersive",
        fn: function fn() {
          return [_c('div', {
            staticClass: "pb-8px pb-md-12px"
          }, [_c('v-row', {
            staticClass: "row--sm",
            attrs: {
              "align": "center"
            }
          }, [_c('v-col', {
            staticClass: "col col-auto"
          }, [_c('h3', {
            staticClass: "txt txt--sm txt--dark font-weight-medium"
          }, [_vm._v(" " + _vm._s(term.subject) + "."), _c('span', {
            staticClass: "pl-4px",
            class: [term.necessary ? 'red--text' : 'grey--text text--lighten-1']
          }, [_vm._v("(" + _vm._s(term.necessary ? "required" : "optional") + ")")])])]), _c('v-spacer'), _c('v-col', {
            staticClass: "col col-auto"
          }, [_c('div', {
            staticClass: "vw-100 w-sm-auto"
          }, [_c('v-checkbox', {
            attrs: {
              "value": _vm.selected.includes(term._id),
              "label": "agreement",
              "hide-details": ""
            },
            on: {
              "click": function click($event) {
                return _vm.toggleSelectedAll(term._id);
              }
            },
            model: {
              value: _vm.agreeTerm,
              callback: function callback($$v) {
                _vm.agreeTerm = $$v;
              },
              expression: "agreeTerm"
            }
          })], 1)])], 1)], 1), _c('v-card', {
            attrs: {
              "outlined": "",
              "tile": ""
            }
          }, [_c('div', {
            staticClass: "pa-16px pa-md-20px mh-120px",
            staticStyle: {
              "overflow-y": "auto"
            }
          }, [_c('div', {
            domProps: {
              "innerHTML": _vm._s(term.content.replace(/\n/gi, '<br/>'))
            }
          })])])];
        },
        proxy: true
      }], null, true)
    })];
  }), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('v-row', {
    staticClass: "row--sm"
  }, [_c('v-col', [_c('v-btn', {
    attrs: {
      "x-large": "",
      "block": "",
      "outlined": "",
      "color": "grey"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])], 1), _c('v-col', [_c('v-btn', {
    attrs: {
      "x-large": "",
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.agree
    }
  }, [_vm._v("Agreement")])], 1)], 1)], 1)], 2) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }